import * as types from "../actions/types";

const initialState = {
  loading: false,
  error: null,
  quotes: [],
  currentQuote: null,
  marketingOrgs: [],
  currentMarketingOrg: null,
};

const facturationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FACTURATION_SET_LOADING:
      return { ...state, loading: action.payload };
    case types.FACTURATION_SET_ERROR:
      return { ...state, error: action.payload };
    case types.FACTURATION_SET_QUOTES:
      return { ...state, quotes: action.payload };
    case types.FACTURATION_SET_CURRENT_QUOTE:
      return { ...state, currentQuote: action.payload };
    case types.FACTURATION_SET_MARKETING_ORGS:
      return { ...state, marketingOrgs: action.payload };
    case types.FACTURATION_SET_CURRENT_MARKETING_ORG:
      return { ...state, currentMarketingOrg: action.payload };
    case types.FACTURATION_UPDATE_QUOTE_IN_LIST:
      return {
        ...state,
        quotes: state.quotes.map((q) =>
          q.id === action.payload.id ? { ...q, ...action.payload } : q
        ),
      };
    case types.FACTURATION_REMOVE_QUOTE_FROM_LIST:
      return {
        ...state,
        quotes: state.quotes.filter((q) => q.id !== action.payload),
      };
    default:
      return state;
  }
};

export default facturationReducer;
